import React from 'react';
import axios from 'axios';
import Wallpaper from './Wallpaper';
import QuickSearch from './Quicksearch';

class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            locations: [],
             mealtype:[]
        };
    }
componentDidMount() {
        axios.get("https://z-5dan.onrender.com/getallLocations")
            .then(response => {
                this.setState({ locations: response.data });
            })
            .catch(error => {
                console.error('Error fetching location data:', error);
            });
            axios.get("https://z-5dan.onrender.com/getallmealtype")
            .then(response => {
                 this.setState({ mealtype:response.data });
            })
            .catch(error => {
                 console.error('Error fetching location data:', error);
             });
    }
    render() {
        const { locations } = this.state;
         const { mealtype } = this.state;
        return (
            <div>
             <Wallpaper locationData={locations} />
             <QuickSearch mealtypeData={mealtype}/>
            </div>
        );  
    }
}

export default Home;


